import { Result, useDownloadFile } from "app/api/hook/use-download-file";

export const useDownloadReportVersionTestCertificatePdf = (versionId: number): Result => {
    const url = new URL(`/api/report_versions/${versionId}/test-certificate.pdf`, document.baseURI);
    return useDownloadFile(url.href);
};
